import { getRequest } from '../api-handler';
import { RunSystemDetailDto } from './runsystem';

export const RunSystemApi = {
  getById: (id: number) => getRequest<RunSystemDetailDto>(`/runsystems/${id}`)
};
